import React, { useLayoutEffect, useState } from "react";
import Product from "../components/Product";
import { database, ref, get } from "../firebase";

function Products({
    path,
    containerClassNames,
    productTextStyles,
    productArticleStyles,
    buttonStyles,
    priceStyles,
    defaultImage,
}) {
    const [products, setProducts] = useState([]);

    useLayoutEffect(() => {
        const dbRef = ref(database, `/${path}/products`);

        get(dbRef)
            .then((snapshot) => {
                if (snapshot.exists()) {
                    setProducts(snapshot.val());
                } else {
                    console.log("No data available");
                }
            })
            .catch((error) => {
                console.error(error);
            });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div
            className={`${containerClassNames} grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-20 px-6 xl:px-24 pb-12 xl:pb-[150px]`}
        >
            {products.map((item, index) => (
                <Product
                    textStyles={productTextStyles}
                    articleStyles={productArticleStyles}
                    buttonStyles={buttonStyles}
                    priceStyles={priceStyles}
                    defaultImage={defaultImage}
                    key={index}
                    item={item}
                />
            ))}
        </div>
    );
}

export default Products;
